import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import { HistoryLockedIllustration } from '@standardnotes/icons';
import Button from '@/Components/Button/Button';
import { useApplication } from '../ApplicationProvider';
import { CorePlanName, PlusPlanName } from '@standardnotes/features';
import { c } from 'ttag';
const getPlanHistoryDuration = (planName) => {
    switch (planName) {
        case CorePlanName:
            return c('B4.Notes.History.Label').t `30 days`;
        case PlusPlanName:
            return c('B4.Notes.History.Label').t `365 days`;
        default:
            return c('B4.Notes.History.Label').t `the current session's changes`;
    }
};
const getPremiumContentCopy = (planName) => {
    const duration = getPlanHistoryDuration(planName);
    const plan = planName !== null && planName !== void 0 ? planName : c('B4.Notes.History.Label').t `free`;
    return c('B4.Notes.History.Label').jt `Version history is limited to ${duration} in the ${plan} plan`;
};
const RevisionContentLocked = () => {
    const application = useApplication();
    let planName;
    if (application.subscriptions.hasOnlineSubscription()) {
        if (!application.subscriptions.isUserSubscriptionCanceled && !application.subscriptions.isUserSubscriptionExpired) {
            planName = application.subscriptions.userSubscriptionName;
        }
    }
    return (_jsx("div", { className: "flex h-full w-full items-center justify-center", children: _jsxs("div", { className: "max-w-40% flex flex-col items-center px-8 text-center", children: [_jsx(HistoryLockedIllustration, {}), _jsx("div", { className: "mb-1 mt-2 text-lg font-bold", children: c('B4.Notes.History.Label').t `Can't access this version` }), _jsxs("div", { className: "leading-140% mb-4 text-passive-0", children: [getPremiumContentCopy(planName), ".", ' ', c('B4.Notes.History.Label').t `Learn more about our other plans to upgrade your history capacity.`] }), application.canShowPurchaseFlow() && (_jsx(Button, { primary: true, label: c('B4.Notes.History.Action').t `Discover plans`, onClick: () => {
                        if (window.plansUrl) {
                            window.location.assign(window.plansUrl);
                        }
                    } }))] }) }));
};
export default observer(RevisionContentLocked);
